import { render, staticRenderFns } from "./Intro-list.vue?vue&type=template&id=0c523570"
import script from "./Intro-list.vue?vue&type=script&lang=js"
export * from "./Intro-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports